import React from 'react';

import styles from './LockedUserMessage.module.scss';

const LockedUserMessage = () => (
  <div className={styles['locked__user--container']}>
    <img src="https://storage.googleapis.com/cdn.lifepal.tech/design-system/icon-alert-red.svg" className={styles.icon} />
    <div>
      <p><b>Tidak ditemukan akun aktif dengan Email / No. telp yang dimasukkan</b><br /></p>
      <p className={styles['top-5p']}>Cek kembali Email/No. telp yang digunakan. Apabila membutuhkan bantuan, silakan kirim email ke helpdesk@lifepal.co.id</p>
    </div>
  </div>
);

export default LockedUserMessage;
